import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FetchUploadStatus } from "./dispatch";

export default function UpdateStatus() {
  const data = JSON.parse(localStorage.getItem("USER_DETAILS"));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(FetchUploadStatus(data));
  }, []);

  const { bulkDataUploadReducer } = useSelector((state) => state);
  const statusUpdateDataArray = bulkDataUploadReducer?.statusUpdateData?.data?.pDATASET;

  return (
    <div style={{ padding: "20px" }}>
      <h2>Upload Status</h2>
      <table  border="1">
      <thead>
          <tr>
          <th style={{ backgroundColor: "#FFF6D6",padding:"8px", textAlign:"center",width:"200px" }}  >Fileload Sequence No</th>
          <th style={{ backgroundColor: "#FFF6D6",padding:"8px", textAlign:"center",width:"200px" }} >File Name</th>
          <th style={{ backgroundColor: "#FFF6D6",padding:"8px", textAlign:"center",width:"200px" }}  >Uploaded Date Time</th>
          <th style={{ backgroundColor: "#FFF6D6",padding:"8px", textAlign:"center",width:"200px" }} >Total Records</th>
          <th style={{ backgroundColor: "#FFF6D6",padding:"8px", textAlign:"center",width:"200px" }} >Success Records</th>
          <th style={{ backgroundColor: "#FFF6D6",padding:"8px", textAlign:"center",width:"200px" }}  >Failed Records</th>
          <th style={{ backgroundColor: "#FFF6D6",padding:"8px", textAlign:"center",width:"200px" }}  >Status</th>
          </tr>
        </thead>
        <tbody>
          {statusUpdateDataArray?.length > 0 ? (
            statusUpdateDataArray.map((item, index) => (
              <tr key={index}>
                  <td style={{ padding:"5px", textAlign:"center" }}>{item.FL_SEQNO}</td>
                 <td style={{ padding:"5px", textAlign:"center" }}>{item.FILE_NAME}</td>
                 <td style={{ padding:"5px", textAlign:"center" }}>{new Date(item.UPLOADED_DATE_TIME).toLocaleString()}</td>
                 <td style={{ padding:"5px", textAlign:"center" }}>{item.TOT_RECORDS}</td>
                 <td style={{ padding:"5px", textAlign:"center" }}>{item.SUC_RECORDS}</td>
                 <td style={{ padding:"5px", textAlign:"center" }}>{item.FAI_RECORDS}</td>
                 <td style={{ padding:"5px", textAlign:"center" }}>{item.STATUS}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="13" align="center">No data available</td>
            </tr>
          )}
        </tbody>
          </table>
    </div>
  );
}
